import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BACKEND_URL } from '@/lib/api';

const HEARTBEAT_INTERVAL = 30000; // 30 seconds
const ANON_KEY = 'nc_anon_id';

function getAnonId() {
  let id = localStorage.getItem(ANON_KEY);
  if (!id) {
    id = `anon_${crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2)}`;
    localStorage.setItem(ANON_KEY, id);
  }
  return id;
}

export default function VisitorHeartbeat() {
  const location = useLocation();

  useEffect(() => {
    // Skip admin/rider/pos routes
    if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/rider') || location.pathname.startsWith('/pos')) {
      return;
    }

    const anonId = getAnonId();

    const sendHeartbeat = () => {
      fetch(`${BACKEND_URL}/api/storefront/heartbeat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ anon_id: anonId, path: location.pathname }),
        keepalive: true,
      }).catch(() => {});
    };

    // Send immediately on page load/route change
    sendHeartbeat();

    // Then every 30 seconds
    const interval = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);

    return () => clearInterval(interval);
  }, [location.pathname]);

  return null;
}
